import { render, staticRenderFns } from "./ViewUserData.vue?vue&type=template&id=ed4214d2"
import script from "./ViewUserData.vue?vue&type=script&lang=js"
export * from "./ViewUserData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports